import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Descriptions,
  List,
  Popconfirm,
} from 'antd';
import i18n from '../../config/i18n';

const SubscriptionList = ({
  subscriptions,
  isLoading,
  actions: {
    getPendingSubscriptions,
    approveSubscription,
    declineSubscription,
  },
}) => {
  useEffect(() => {
    getPendingSubscriptions();
  }, [getPendingSubscriptions]);

  return (
    <div>
      <h2>
        {i18n.t('subscriptionList')}
      </h2>
      <List
        bordered
        loading={isLoading}
        dataSource={subscriptions}
        renderItem={item => (
          <List.Item
            actions={[
              <Button
                type="primary"
                onClick={() => { approveSubscription(item.id); }}
              >
                {i18n.t('approve')}
              </Button>,
              <Popconfirm
                title="Sure to decline?"
                onConfirm={() => { declineSubscription(item.id); }}
              >
                <Button
                  type="danger"
                >
                  {i18n.t('decline')}
                </Button>
              </Popconfirm>,
            ]}
          >
            <List.Item.Meta
              title={
                <div style={{ paddingBottom: 12 }}>
                  <span style={{ fontSize: 24 }}>
                    {item.firstName} {item.lastName}
                  </span>
                </div>
              }
              description={
                <Descriptions column={1}>
                  <Descriptions.Item label="Team">
                    {item.teamName}
                  </Descriptions.Item>
                  <Descriptions.Item label="Plan">
                    {item.planName}
                  </Descriptions.Item>
                </Descriptions>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

SubscriptionList.propTypes = {
  subscriptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    teamName: PropTypes.string.isRequired,
    planName: PropTypes.string.isRequired,
  })),
  isLoading: PropTypes.bool,
  actions: PropTypes.shape({
    getPendingSubscriptions: PropTypes.func.isRequired,
    approveSubscription: PropTypes.func.isRequired,
    declineSubscription: PropTypes.func.isRequired,
  }).isRequired,
};

SubscriptionList.defaultProps = {
  subscriptions: [],
  isLoading: false,
};

export default SubscriptionList;



// WEBPACK FOOTER //
// ./src/components/team/SubscriptionList.js